module.exports = __webpack_public_path__ + "static/media/Martin_trabajando.237f4809.png";